import React, {useState} from 'react';
import MediaPopup from '@components/SpecialistDoctor/MediaPopup';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import {safeHtml} from '@helper/sanitize-html';

export default function AboutUsStory(props) {
    const {onOpenPopup, story, mission, vision} = props;
    const {locale} = useRouter();
    const content = locale === 'en' ? story?.sub_title_en : story?.sub_title;
    const textPart = content;

    const [isMediaPopupOpen, setIsMediaPopupOpen] = useState(false);
    const [customerComment, setCustomerComment] = useState({
        media_url: '',
        media_type: 'image',
    });

    const openMedia = url => {
        if (!url) return;
        setCustomerComment({
            media_url: url,
            media_type: 'image',
        });
        setIsMediaPopupOpen(true);
    };

    return (
        <div className="about-us__story">
            <div className="about-us__media">
                {/* Click vào main_image */}
                <img
                    src={story?.main_image}
                    alt="Bệnh viện TNH"
                    className="about-us__cover"
                    onClick={() => openMedia(story?.main_image)}
                    style={{cursor: 'pointer'}}
                />

                <div className="about-us__video">
                    <div className="about_us-img">
                        {/* Click vào sub_image */}
                        <img
                            src={story?.sub_image}
                            alt="Video giới thiệu"
                            className="about-us__video-thumb"
                            onClick={() => openMedia(story?.sub_image)}
                            style={{cursor: 'pointer'}}
                        />
                        <div className="about-us_btn_play" onClick={() => openMedia(story?.sub_image)}>
                            {/* <img src="/bw_image/ic_play_btn.svg" alt="Play" /> */}
                        </div>
                    </div>

                    <div className="about-us__experience">
                        <div className="number">{story?.number_year}</div>
                        <div className="text">{textPart}</div>
                    </div>
                </div>
            </div>

            <div className="about-us__content">
                <div className="about-us__contet-title">
                    <h2 className="about-us__title">{locale === 'en' ? story?.title_en : story?.title}</h2>
                    <p
                        className="about-us__desc"
                        dangerouslySetInnerHTML={safeHtml(
                            locale === 'en' ? story?.description_en : story?.description,
                        )}
                    />
                </div>

                <div className="about-us__vision-mission">
                    {/* Vision */}
                    <div className="about-us__item">
                        <img src="/bw_image/ic_vision.png" alt="Tầm nhìn" className="about-us__icon" />
                        <div>
                            <h3>{locale === 'en' ? vision?.title_en : vision?.title}</h3>
                            <p
                                dangerouslySetInnerHTML={safeHtml(
                                    locale === 'en' ? vision?.short_description_en : vision?.short_description,
                                )}
                            />
                            <div className="about-us__content_moreInfo">
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        onOpenPopup({
                                            type: 'vision',
                                            title: getLocaleContent(locale, 'page.about-us.vision'),
                                            content: [
                                                locale === 'en'
                                                    ? vision?.more_description_en
                                                    : vision?.more_description,
                                            ],
                                            image: vision?.popup_bg_image,
                                        });
                                    }}>
                                    {getLocaleContent(locale, 'page.about-us.more') + ' →'}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Mission */}
                    <div className="about-us__item">
                        <img src="/bw_image/ic_mission.png" alt="Sứ mệnh" className="about-us__icon" />
                        <div>
                            <h3>{locale === 'en' ? mission?.title_en : mission?.title}</h3>
                            <p
                                dangerouslySetInnerHTML={safeHtml(
                                    locale === 'en' ? mission?.short_description_en : mission?.short_description,
                                )}
                            />
                            <div className="about-us__content_moreInfo">
                                <a
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();
                                        onOpenPopup({
                                            type: 'mission',
                                            title: getLocaleContent(locale, 'page.about-us.mission'),
                                            content: [
                                                locale === 'en'
                                                    ? mission?.more_description_en
                                                    : mission?.more_description,
                                            ],
                                            image: vision?.popup_bg_image,
                                        });
                                    }}>
                                    {getLocaleContent(locale, 'page.about-us.more') + ' →'}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Popup hiển thị ảnh */}
            <MediaPopup
                isOpen={isMediaPopupOpen}
                onClose={() => setIsMediaPopupOpen(false)}
                type={customerComment.media_type}
                src={customerComment.media_url}
            />
        </div>
    );
}
